import { useDispatch } from '@redux';
import { login } from '@redux/auth/actions';
import { Button, Form, Input } from 'antd';
// import SocialButtons from 'containers/Login/SocialButtons';
// import TermCondition from 'containers/Login/TermCondition';
import LoginWrapper from 'containers/Login/styles';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export default function Login() {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const onFinish = (v) => {
    dispatch(login(v)).then(({ payload }) => {
      payload.accessToken && navigate('/');
    });
  };
  return (
    <LoginWrapper>
      <Form onFinish={onFinish} form={form}>
        <Form.Item
          name="email"
          rules={[
            {
              required: true,
              message: t('error.email.required'),
            },
            {
              type: 'email',
              message: t('error.email.invalid'),
            },
          ]}
        >
          <Input placeholder="Email" />
        </Form.Item>
        <Form.Item
          className="mb-2.5"
          name="password"
          rules={[
            {
              required: true,
              message: t('error.password.required'),
            },
          ]}
        >
          <Input.Password placeholder="Password" />
        </Form.Item>
        <div
          className="forgot-password cursor-pointer w-fit ml-auto"
          onClick={() => navigate('/reset-password')}
        >
          {t('common.auth.forgotPassword')}
        </div>
        <Button htmlType="submit" type="primary" className="mt-5 w-full">
          Sign in
        </Button>
      </Form>
      {/* <Divider>or</Divider>
      <SocialButtons />
      <div className="d-flex mt-5 flex-center">
        Don’t have an account?
        <Link className="ml-2.5 fw-500 text-sm" to="/register">
          Create an account
        </Link>
      </div>
      <TermCondition /> */}
    </LoginWrapper>
  );
}
